import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import styled from "styled-components";
import Notifications, { error as errorNotif } from "react-notification-system-redux";

import { userActions } from "_store/actions";

import breakpoints from "_constants/breakpoints";

import imgBanner from "assets/img/HomeBanner_centeredLogo.jpg";

import { ResetPasswordSuccess } from "components/Modals";

import Brand from "widget/Brand";

const Layout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: url(${imgBanner}) no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 624px;

  @media (max-height: 624px) {
    min-height: 0;
  }
`;
const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Header = styled.div`
  padding: 15px 15px 0;
  display: flex;
  justify-content: center;
`;
const Content = styled.div`
  padding: 15px 15px 10px;
  font-size: 22px;
  line-height: 30px;

  .login-message {
    font-size: 18px;
    text-align: center;
  }

  @media (max-width: ${breakpoints.mobileS}) {
    font-size: 12px;
    line-height: 14px;

    .form-control {
      font-size: 12px;
    }
  }
`;
const Group = styled(Form.Group)`
  margin-bottom: 1rem;
`;
const StyledButton = styled(Button)`
  font-size: 1em;
`;
const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ButtonLink = styled.button`
  border: none;
  background: none;
  color: #0d6efd;
  text-decoration: underline;
`;

export default function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { resetPasswordStatus } = useSelector(({ user }) => user);
  const { notifications } = useSelector((store) => store);

  const [email, setEmail] = useState("");
  const [request, setRequest] = useState(false);

  const handleChange = ({ target: { value } }) => setEmail(value);

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (email) {
      if (emailRegex.test(email)) {
        dispatch(userActions.resetPassword({ email, category: "TRADEMARKS" }));
        setRequest(true);
      } else {
        dispatch(errorNotif({ title: "Error", message: "Enter valid email addess in format 'name@example.com'" }));
      }
    }
  };

  return (
    <Layout>
      <Container fluid>
        <Row className="justify-content-center mt-5">
          <Col xs={10} md={6} lg={4}>
            <div className="card">
              <Header>
                <Brand />
              </Header>
              <Content>
                <StyledForm onSubmit={handleSubmit}>
                  <Group controlId="formBasicEmail">
                    <Form.Label>
                      Forgot your password?
                      <br />
                      Enter your e-mail below for us to send you a reset code
                    </Form.Label>
                    <Form.Control required type="email" placeholder="Email" value={email} onChange={handleChange} />
                  </Group>

                  <Buttons>
                    <ButtonLink type="button" onClick={() => navigate("/login")}>
                      Log in
                    </ButtonLink>
                    <StyledButton variant="primary" type="submit">
                      Reset
                    </StyledButton>
                  </Buttons>
                </StyledForm>
              </Content>
            </div>
          </Col>
        </Row>
      </Container>
      {request && resetPasswordStatus === "success" && <ResetPasswordSuccess />}

      <Notifications notifications={notifications} />
    </Layout>
  );
}
